module.exports = __webpack_public_path__ + "static/media/sdk-1.4c3650c0.svg";